/**
 * Returns the first fulfilled promise from an array of promises.
 */
export const getFirstFulfilled = async <T>(
  promises: Promise<T>[],
): Promise<T> => {
  const responses = await Promise.allSettled(promises);

  for (let i = 0; i < promises.length; i++) {
    const response = responses[i]!;

    if (response.status === 'fulfilled') {
      return response.value;
    }
  }

  throw (responses[0] as PromiseRejectedResult).reason;
};

/**
 * Returns the result of the first fulfilled promise from a sequence of functions.
 */
export const getFirstFulfilledInSequence = async (
  sequence: ((...args: any) => Promise<any>)[],
  ...args: any
) => {
  let result: any;
  let error: any;

  for (let i = 0; i < sequence.length; i++) {
    try {
      const promiseResult = await sequence[i]!.call(null, ...args);

      result = promiseResult;
      break;
    } catch (e) {
      error = e;
    }
  }

  if (!result) {
    throw error;
  }

  return result;
};
